export default __webpack_public_path__ + "static/media/epi-sugarcane.1f5d29c1.jpg";